module.exports = __webpack_public_path__ + "static/mongo-6eee662a032695d79829cb115729061d.png";